import apiClient from './index';
import { ReportConfigMetaResponse } from './types';

export const reportConfigApi = {
  async getMeta(): Promise<ReportConfigMetaResponse> {
    const response = await apiClient.get<ReportConfigMetaResponse>('/report-config/meta');
    return response.data;
  },
};
